export default {
  data() {
    return {
      mobileDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortLibraryFiles(
                  this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.col,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortLibraryFiles(
                  this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.col,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
        {
          title: this.$t("dropdowns.sortingBy"),
          options: [
            {
              label: this.$t("library.labels.fileName"),
              key: "title",
              method: () => {
                this.sortLibraryFiles(
                  "title",
                  this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("filters.created_at"),
              key: "created_at",
              method: () => {
                this.sortLibraryFiles(
                  "created_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      sortMainColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          key: "title",
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortLibraryFiles("title", "ASC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortLibraryFiles("title", "DESC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsFirstColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: true,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortLibraryFiles(
                  this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.showAs.firstCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortLibraryFiles(
                  this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.showAs.firstCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: true,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("library.labels.fileType"),
              key: "file_extension",
              method: () => {
                this.changeCol({
                  list: "libraryFiles",
                  showAs: {
                    firstCol: {
                      label: "library.labels.fileType",
                      key: "file_extension",
                      format: "none",
                      size: 1,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("library.labels.size"),
              key: "file_size",
              method: () => {
                this.changeCol({
                  list: "libraryFiles",
                  showAs: {
                    firstCol: {
                      label: "library.labels.size",
                      key: "file_size",
                      format: "size",
                      size: 1,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("filters.created_at"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "libraryFiles",
                  showAs: {
                    firstCol: {
                      label: "filters.created_at",
                      key: "created_at",
                      format: "date",
                      size: 1,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      filterDropdown: [
        {
          title: this.$t("library.filter"),
          options: [],
        },
      ],
    };
  },
};
